// extracted by mini-css-extract-plugin
module.exports = {"compactWrapper":"ReceiverLocationSelector_compactWrapper__3RxlF","receiverLocation":"ReceiverLocationSelector_receiverLocation__27omt"};